import React, { FC, useEffect, useRef, useState } from 'react';
import styles from './RatingForm.module.css';
import { useRateProduct } from '@services/useRateProduct';
import { useNotifications } from '@hooks/useNotifications';

export interface RatingFormProps {
    productUuid: string;
    startValue?: number | null;
}

const AVAILABLE_RATING = [5, 4, 3, 2, 1];

export const RatingForm: FC<RatingFormProps> = ({ productUuid, startValue }) => {
    const { showDefaultNotification } = useNotifications();
    const { request: requestRateProduct, loading, errorMessage, validationErrors, lastResponseTime } = useRateProduct();

    const [rating, setRating] = useState<number | null>(startValue || null);

    const submitBtnRef = useRef<HTMLButtonElement>(null);

    const handleOnClickStar = (value: number) => {
        if (value > 0 && value !== rating) {
            setRating(value);
            requestRateProduct({ uuid: productUuid, rating: value });
        }
    };

    useEffect(() => {
        if (!lastResponseTime) {
            return;
        }

        const validationMessage =
            validationErrors && typeof validationErrors === 'object'
                ? (Object.values(validationErrors) as unknown[])
                      .flat()
                      .find((message): message is string => typeof message === 'string' && message.trim().length > 0) ?? null
                : null;

        const notificationMessage = errorMessage ?? validationMessage;

        if (typeof notificationMessage === 'string' && notificationMessage.trim().length > 0) {
            showDefaultNotification({ type: 'error', message: notificationMessage });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastResponseTime]);

    return (
        <div className={`${styles['rating-form']} d-inline-block`}>
            <>
                {AVAILABLE_RATING.map((item) => (
                    <input
                        key={`star-${item}`}
                        type="radio"
                        name={`${productUuid}-rating`}
                        value={item}
                        defaultChecked={item === rating}
                        onClick={() => handleOnClickStar(item)}
                        disabled={loading}
                    />
                ))}
            </>
            <button ref={submitBtnRef} type="submit" className="d-none"></button>
        </div>
    );
};
